module.exports = __webpack_public_path__ + "account/assets/refuse-trip-close.64de32c9.svg";